var Bavaria = "Bavyera";
var Berlin = "Berlin";
var Brandenburg = "Brandenburg";
var Bremen = "Bremen";
var Hamburg = "Hamburg";
var Hesse = "Hessen";
var Saarland = "Saarland";
var Saxony = "Saksonya";
var Thuringia = "Thüringen";
var DEStates = {
	"Baden-Wuerttemberg": "Baden-Württemberg",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "Mecklenburg-Vorpommern",
	"Lower Saxony": "Aşağı Saksonya",
	"North Rhine-Westphalia": "Kuzey Ren-Vestfalya",
	"Rhineland-Palatinate": "Renanya-Palatina",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "Saksonya-Anhalt",
	"Schleswig-Holstein": "Schleswig-Holstein",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
